export default __webpack_public_path__ + "static/media/fujairah-DED.f8c5a7d8.png";